// A tab switch unmounts and remounts the whole route, so every list screen's
// `useState(null)` reset to null and re-fetched — same data, same spinner,
// every single time you came back to a tab you'd already loaded. This is a
// module-level (survives remounts, not page reloads) cache of "last thing we
// fetched for this key", so a screen can render instantly from what it showed
// a second ago while quietly re-fetching underneath. Not for correctness —
// just for skipping a spinner nobody needed to see twice.
const cache = new Map()

export function getCached(key) {
  return cache.has(key) ? cache.get(key) : null
}

export function setCached(key, value) {
  cache.set(key, value)
}
